import { CustomAlert } from 'components/AlertsCollection';
import { ResponseError } from 'services/api/base';

export const RATE_LIMIT_DEFAULT_MESSAGE = 'Muitas requisições em sequência. Aguarde um minuto e tente novamente.';

// Recusa por limite de tentativas: o backend responde HTTP 200 com `code: 429`
// (base.messages.rate_limited, backend#67). É um aviso para esperar, não uma falha:
// mostrar na própria tela em vez de mandar para /error (issue #1958).
// Só o envelope do WSGI (com `data`) conta: um HTTP 429 de proxy/WAF, sem corpo, segue
// para o handleApiError (Sentry + /error), para não virar um aviso vazio.
export const isRateLimited = (error: unknown): error is ResponseError => (
  typeof error === 'object' && error !== null && 'status' in error
  && +(error as ResponseError).status === 429
  && typeof (error as ResponseError).data === 'string'
);

export const rateLimitAlert = (error: ResponseError): CustomAlert => ({
  title: error.data,
  message: error.description || RATE_LIMIT_DEFAULT_MESSAGE,
  variant: 'warning',
});
